var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-column full-height justify-center bg-base"},[_c('div',{staticClass:"text-center ptb-30"},[_c('v-icon',{staticClass:"size-px-48"},[_vm._v("mdi-cloud-off-outline")]),_c('p',{staticClass:"mt-10 size-px-16"},[_vm._v(_vm._s(_vm.text_none))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }